export default function registerMsg($, apower) {
  //msg
  $.msg = $.newComponent('win', {

    template: `
		<div class="win msg" :class="['msg-' + type, class]" f-loading="loading">
			<div class="win-body msg-body" ref="body">
				<div class="msg-title" f-html="title" f-show="title"></div>
				<div class="msg-text" f-html="message" f-show="message"></div>
				<div class="msg-field" f-show="type === 'prompt'">
					<input class="msg-input" type="text" f-model="value" @keydown="onKeydown('ok')" required :attr="inputAttributes" ref="input">
				</div>
			</div>
			<div class="win-foot msg-foot" ref="foot">
				<button f-for="btn, text in buttons"
					f-disable="type === 'prompt' && btn === 'ok' && !value"
					@click="handleButton(btn)"
					:attr.type="btn === 'ok' ? 'primary' : ''"
				>{{text}}</button>
			</div>
		</div>
	`,

    type: '',

    target: '',

    onReady () {
      this.closeEl.$on('click', this.onCancelMsg, this)
    },

    onCancelMsg (e) {
      this.handleButton('cancel')
    },

    onKeydown (e) {
      if (e.keyCode === 10 || e.keyCode === 13) {
        this.handleButton('ok')
      }
    },

    handleButton (buttonType) {
      this.hide()

      if (this.fn) {
        this.fn.call(this.scope, buttonType, this.value)
      }

      this.resolve(this.type === 'prompt' ? buttonType === 'ok' ? this.value : '' : buttonType)
    },

    showMsg (type, buttons, title, msg, fn, scope, options) {
      if (!this.el.parent().length) {
        this.el.appendTo('body')
      }

      if (typeof buttons === 'string') {
        scope = fn
        fn = msg
        msg = title
        title = buttons
        buttons = null
      }

      if (typeof msg !== 'string') {
        scope = fn
        fn = msg
        msg = title
        title = ''
      }

      if (typeof fn !== 'function') {
        options = fn
        fn = null
      }

      options = options || {}

      this.type = type
      this.buttons = buttons || options.buttons
      this.title = title || options.title
      this.message = msg
      this.fn = fn || options.handler
      this.scope = scope
      this.value = options.value || ''
      this.class = options.class
      this.inputAttributes = options.inputAttributes

      if (!this.buttons) {
        this.buttons = this.defaultButtons[type]
      }

      if (Array.isArray(this.buttons)) {
        this.buttons = this.buttons.index(btn => [btn, apower.tr(this.buttonTexts[btn])])
      }

      this.promise = new Promise(resolve => {
        this.resolve = resolve
      })

      $.digest()

      $.nextTick(() => {
        this.show()

        if (this.type === 'prompt') {
          this.input.focus()
        }
      })

      return this.promise
    },

    buttonTexts: {
      ok: 'OK@@001410',
      yes: 'Yes@@yes',
      no: 'No@@no',
      cancel: 'Cancel@@cancel',
    },

    defaultButtons: {
      info: [],
      alert: ['ok'],
      error: ['ok'],
      success: ['ok'],
      prompt: ['ok'],
      confirm: ['cancel', 'ok'],
    },

    info (...args) {
      return this.showMsg('info', ...args)
    },

    alert (...args) {
      return this.showMsg('alert', ...args)
    },

    error (...args) {
      return this.showMsg('error', ...args)
    },

    success (...args) {
      return this.showMsg('success', ...args)
    },

    prompt (...args) {
      return this.showMsg('prompt', ...args)
    },

    confirm (...args) {
      return this.showMsg('confirm', ...args)
    },
  })

}